<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(item,tabIndex) in data" :label="item.label" :name="item.name" :key="tabIndex">
        <span slot="label" v-if="item.showBadge">
          <el-badge style="margin-top: 10px;margin-bottom: 10px" :value="pageTotal[item.name] === 0 ? '':pageTotal[item.name]"
            :max="99">{{item.label}}</el-badge>
        </span>
      </el-tab-pane>
    </el-tabs>
    <w-table :columns="columns" :table-data="tableData" ref="wMyTable" :isPagination="true"
      @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }"
      @rowSelection="rowSelection($event)" :isShowRowSelection="true" :key="activeTab"
      :table-col-check="{isShow:true,name:'TerminateApplyAudit2' + activeTab}" :page="page"
      @pageChange="handlePagePagination">
      <template slot="operation" slot-scope="{text,record}">
        <el-button size="mini" type="primary" v-if="record.status === 'APPLYING' && !isAuditViewOnly"
          @click="handleEdit(record)">审核</el-button>
        <el-button size="mini" type="success" v-if="record.status === 'APPLYING' && isAuditViewOnly"
          @click="handleAuditDetails(record)">查看详情</el-button>
        <el-button size="mini" type="success" v-if="record.status !== 'APPLYING'"
          @click="handleDetails(record)">查看详情</el-button>
      </template>
      <template slot="contractName" slot-scope="{text,record,index,column}">
        <w-ellipsis-and-look :text="text" :column="column"></w-ellipsis-and-look>
      </template>
      <template slot="contractNumber" slot-scope="{text,record,index,column}">
        <span>{{text}}</span>
        <el-tooltip content="复制">
          <a-icon type="copy" style="color: #3f9dfe" @click="copyData(text)" />
        </el-tooltip>
      </template>
      <template slot="executeContractNumber" slot-scope="{text,record}">
       <div v-if="text">
          <span>{{ text }}</span>
          <el-tooltip content="复制">
            <a-icon type="copy" style="color: #3f9dfe" @click="copyData(text)" />
          </el-tooltip>
        </div>
        <span v-else>{{'NA'}}</span>
      </template>
      <template slot="addedAmount" slot-scope="{text,record}">
        <span v-if="['PREPAYMENTS','IMPORT_PREPAYMENTS'].includes(record.data.contractType)">{{text}}</span>
        <span v-else>{{'NA'}}</span>
      </template>
      <template slot="contact" slot-scope="{text,record}">
        <el-tooltip effect="dark" content="查看客户信息" placement="bottom" v-if="text">
          <el-link type="primary" :underline="false" @click="showContact(record)"><i
              v-html="viewDetailIcon"></i></el-link>
        </el-tooltip>
        <span>{{text}}</span>
      </template>
      <template slot="status" slot-scope="{text,record}">
        <span style="display: flex;align-items: center">
          <el-tag :type="getStatusColor(text,'tagType')"
            :style="{color: getStatusColor(text,'color'),'background-color':getStatusColor(text,'backgroundColor')}">
            {{getStatusColor(text,'name')}}</el-tag>
          <w-ellipsis-and-look v-if="['DEFEAT', 'SUCCESS'].includes(text)" style="margin-left:5px"
            class="w-ellipsis-and-look" :text="record['rejectionReason']" :column="{title:'驳回原因'}" :onlyDetail="true"
            :isOpenHtml="false">
          </w-ellipsis-and-look>
        </span>
      </template>
      <template slot="impairmentFlag" slot-scope="{text,record}"
        style="display: flex;align-items: center;justify-content: center;">
        <el-tag v-if="text === 0" type="danger">否</el-tag>
        <span v-else-if="text === 1" style="display: flex;align-items: center">
          <el-tag type="success">是</el-tag>
          <el-tooltip effect="dark" style="margin-left:5px" content="查看转预付款信息" placement="bottom">
            <el-link type="primary" :underline="false" @click="showImpairment(record)"><i
                v-html="viewDetailIcon"></i></el-link>
          </el-tooltip>
        </span>
      </template>
      <template slot="contractType" slot-scope="{text,record}">
        <el-tag :type="getContractColor(text, 'tagType')" :style="{
          color: getContractColor(text, 'color'),
          'background-color': getContractColor(text, 'backgroundColor'),
          'border-color': getContractColor(text, 'borderColor')
        }">
          {{ getContractColor(text, 'name') }}</el-tag>
      </template>
      <template slot="filterStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='待审核'>待审核</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='已通过'>已通过</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='已驳回'>已驳回</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </template>
      <template slot="filterContractType" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='预付款'>预付款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='正式'>正式</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='扣款'>扣款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='老系统预付款'>老系统预付款</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='研发'>研发</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">
            搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </template>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
    <contract-details v-if="showDetailsDialog" :show-dialog="showDetailsDialog" :select-detail="[showDetails]"
      @submit="close"></contract-details>
    <terminate-audit-dialog v-if="showCheckDialog" :show-dialog="showCheckDialog" :select-detail="selectDetail"
      :readonly="isAuditViewOnly" @submit="closeCheckDialog"></terminate-audit-dialog>
    <customer-user-info :show-dialog="showContactInfo" v-if="showContactInfo" :select-detail="contactInfo"
      @submit="closeShowContact"></customer-user-info>
    <impairment-info :show-dialog="showImpairmentInfo" v-if="showImpairmentInfo" :select-detail="impairmentInfo"
      @submit="closeShowImpairment"></impairment-info>
  </div>
</template>

<script>

import ContractDetails from "@/components/sales/ContractDetails.vue";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import ExFoldTable from "@/components/ExFoldTable.vue";
import {getAuditPage} from "@/api/dilivery/audit";
import {tableOperationMixin} from "@/mixins/tableOperation";
import ChangeContractAudit from "@/components/check/ChangeContractAudit.vue";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import _ from "lodash";
import {TerminateApplyAudit} from "@/utils/data/tableCol/audit/TerminateApplyAudit/TerminateApplyAudit";
import TerminateAuditDialog from "@/components/check/TerminateAuditDialog.vue";
import {getContractColor, getStatusColor} from "@/color";
import CustomerUserInfo from "@/components/customer/CustomerUserInfo.vue";
import ImpairmentInfo from "@/components/impairment/ImpairmentInfo.vue";
import {viewDetailIcon} from "@/utils/icon";
import {copyText} from "@/utils/windowsUtils";
import {auditViewOnlyMixin} from "@/mixins/auditViewOnlyMixin";

export default {
  name: "TerminateApplyAudit",
  components: {
    ImpairmentInfo, CustomerUserInfo,
    TerminateAuditDialog,
    PictureLoading, ChangeContractAudit, ExFoldTable, TableHeadNote, ContractDetails},
  mixins: [tableOperationMixin, auditViewOnlyMixin],
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      data: [
        { label: '全部', name: 'ALL', showBadge: false },
        { label: '待审批', name: 'APPLYING', showBadge: true },
        { label: '已通过', name: 'SUCCESS', showBadge: false },
        { label: '已驳回', name: 'DEFEAT', showBadge: false },
      ],
      sendData: {
        ALL: {},
        APPLYING: { "query#status.EQ": "APPLYING" },
        SUCCESS: { "query#status.EQ": "SUCCESS" },
        DEFEAT: { "query#status.EQ": "DEFEAT" },
      },
      pageTotal: { ALL: 0, APPLYING: 0, SUCCESS: 0, DEFEAT: 0 },
      loading: true,
      viewDetailIcon: viewDetailIcon,
      contactInfo: [],
      showContactInfo: false,
      impairmentInfo: {},
      showImpairmentInfo: false,
      activeTab: 'APPLYING',
      showCheckDialog: false,
      selectDetail: '',
      showDetailsDialog: false,
      showDetails: '',
    }
  },
  computed: {
    columns() {
      let keys = ['rejectionReason', 'operator', 'auditTime']
      let cols = TerminateApplyAudit([] || {})
      if (this.activeTab === "APPLYING") {
        return JSON.parse(JSON.stringify(cols.filter(item => !keys.includes(item.key))))
      } else {
        return JSON.parse(JSON.stringify(cols))
      }
    },
  },
  mounted() {
    this.loadAllTabTotals()
    this.getData()
  },
  methods: {
    getStatusColor,
    getContractColor,
    loadAllTabTotals() {
      // 销售侧角色（SALES_MANAGER、SALES）仅查看详情，不发起标签页红点数量查询
      if (this.isAuditViewOnly) return
      Object.keys(this.sendData).forEach(tabName => {
        let sendData = { ...this.sendData[tabName] }
        getAuditPage({ 'page.current': 1, 'page.size': 1 }, sendData, 'CONTRACT_TERMINATE_AUDIT').then(res => {
          if (res.code === 200) {
            this.$set(this.pageTotal, tabName, parseInt(res.data.total))
          }
        })
      })
    },
    changeTab() {
      this.$nextTick(() => {
        this.tableData = []
        this.selectable = []
        this.searchConditionTag = []
        this.sortConditionTag = []
        this.page = { pageSize: 10, currentNum: 1, total: null }
        if (this.$refs.wMyTable) {
          this.$refs.wMyTable.selectedRowKeys = []
          this.$refs.wMyTable.searchConditionTag = []
        }
        this.getData()
      })
    },
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id));
    },
    copyData(text) {
      copyText(text)
      this.$messageUi.success('复制成功')
    },
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    showContact(row) {
      this.contactInfo = [row.data.customerContacts]
      this.showContactInfo = true
    },
    closeShowContact() {
      this.showContactInfo = false
    },
    showImpairment(row) {
      this.impairmentInfo = row.data
      this.showImpairmentInfo = true
    },
    closeShowImpairment() {
      this.showImpairmentInfo = false
    },
    getData(searchFlag) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10 }
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let sendData = { ...this.sendData[this.activeTab] }
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }
      getAuditPage(params, sendData, 'CONTRACT_TERMINATE_AUDIT').then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
          // 销售侧角色不展示标签页红点数量
          if (!this.isAuditViewOnly) {
              this.$set(this.pageTotal, this.activeTab, parseInt(res.data.total))
          }
        }
      }).catch(error => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      
      this.searchConditionTag.forEach(item => {
        let value = item.value
        if (item.key === 'status') {
          if (item.value === '待审核') {
            value = 'APPLYING'
          } else if (item.value === '已通过') {
            value = 'SUCCESS'
          } else {
            value = 'DEFEAT'
          }
        } else if (item.key === 'contractType') {
          if (item.value === '预付款') {
            value = 'PREPAYMENTS'
          } else if (item.value === '老系统预付款') {
            value = 'IMPORT_PREPAYMENTS'
          } else if (item.value === '研发') {
            value = 'DEVELOPMENT'
          } else if (item.value === '正式') {
            value = 'FORMAL'
          } else {
            value = 'CHARGEBACKS'
          }
        } else if (item.key === 'contractNumber') {
          value = value.replace(/[A-Za-z]/g, "")
        }
        if (['contractNumber','contractType','auditCharge','contactName','salesName'].includes(item.key)) {
          sendData[item.key] = value
        } else {
          sendData["query#" + item.key + ".LIKE"] = value
        }
      })
      return sendData
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    async handleEdit(row) {
      try {
        this.selectDetail = row
        this.showCheckDialog = true
      } catch (error) {
        console.log(error);
        this.showCheckDialog = false
        this.$messageUi.error('打开审核页面失败')
      }
    },
    handleDetails(row) {
      this.showDetails = row.data
      this.showDetailsDialog = true
    },
    // 只读角色查看待审批的终止申请详情（复用审核弹窗，隐藏审核操作区）
    handleAuditDetails(row) {
      this.selectDetail = row
      this.showCheckDialog = true
    },
    closeCheckDialog() {
      this.getData()
      this.$nextTick(() => {
        this.showCheckDialog = false
      })
    },
    close() {
      this.$nextTick(() => {
        this.showDetailsDialog = false
      })
    }
  }
}
</script>

<style scoped>
</style>
